module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"#8b8b8b\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,4.75A1.25,1.25,0,1,1,10.75,8,1.25,1.25,0,0,1,12,6.75ZM15,17H9V15h2V12H10V10h2a1,1,0,0,1,1,1v4h2Z\" />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/info.svg
// module id = 802
// module chunks = 1